// native
import { Component, ChangeDetectionStrategy, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

// service
import { GlobalsService } from '../../services/globals.service';
import { ItemsDisplayService } from '../../services/items-display.service';
import { ActiveReferencesService } from '../../services/active-references.service';
import { CustomStyleService } from '../../services/custom-style.service';
import { CitationsEventService } from '../../services/citations-event.service';
import { ListService } from '../../services/list.service';

// model
import { ICitationSelection } from '../../../models';

@Component({
  selector: 'scs-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, OnDestroy {

  citationSelectedSubscription: Subscription;

  tabOptions = [
    "references",
    "bibliography",
    "options"
  ];

  constructor(
    public globalsService: GlobalsService,
    private itemsDisplayService: ItemsDisplayService,
    private listService: ListService,
    private activeReferencesService: ActiveReferencesService,
    private customStyleService: CustomStyleService,
    private citationsEventService: CitationsEventService
  ) { }

  ngOnInit() {
    this.citationSelectedSubscription = this.citationsEventService.citationSelected$.subscribe((selection: ICitationSelection) => {
      !!selection?.items && this.onTabClick(0);
    });
  }

  ngOnDestroy() {
    this.citationSelectedSubscription?.unsubscribe;
  }

  onTabClick(index: number) {
    this.globalsService.navigateToTab(index);
    this.itemsDisplayService.itemsVisible$.next(false);
    this.listService.currentList$.next(null);

    this.activeReferencesService.areActiveReferencesShown = false;
    this.customStyleService.isCustomStyleDialogOpen = false;
  }
}
